module.exports = __webpack_public_path__ + "static/img/tongji.0e26a94d.png";